import { isRomanNumeral } from '../isRomanNumeral';

const capitalizeWords = (words: string): string => 
  // Split by word boundaries and process each word
  words.split(/\s+/).map(word => {
    // If the word is a Roman numeral, return it in uppercase
    if (isRomanNumeral(word)) {
      return word.toUpperCase();
    }
    // Otherwise, capitalize the first letter only
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ')
;

export default capitalizeWords;
